<template>
  <div class="pa-2">
    <div v-if="!itemSlug" class="d-flex flex-row justify-space-between">
      <div class="text-h5">RGP Lenses Admin</div>
      <div>
        <v-btn depressed text :to="{ path: '/boss/rgp-lenses/new' }"
          ><v-icon color="green" class="mr-1">mdi-plus</v-icon> Add Lens</v-btn
        >
      </div>
    </div>
    <v-fade-transition>
      <generic-admin-list
        v-if="!itemSlug"
        idField="slug"
        title="RGP Lenses"
        :headers="headers"
        api="rgpLenses"
        editPath="/boss/rgp-lenses"
        detailPath="/rgps/details/"
        :refresh="refresh"
        itemsKey="items"
        actionField="lens"
        @loaded="refresh = false"
        class="my-2"
      ></generic-admin-list>

      <edit-rgp-lens
        v-else
        :slug="itemSlug"
        class="my-2"
        @cancel="itemSlug = null"
      >
      </edit-rgp-lens>
    </v-fade-transition>
  </div>
</template>

<script>
import GenericAdminList from "@/components/adminStuff/GenericAdminList";
import EditRgpLens from "./EditRgpLens.vue";

export default {
  name: "RgpLensesAdminHome",
  components: { GenericAdminList, EditRgpLens },
  props: {},
  data: function () {
    return {
      refresh: true,

      itemSlug: null,
      headers: [
        { value: "id", text: "Id" },
        { value: "lens", text: "Lens" },
        { value: "company", text: "Company" },
        { value: "display", text: "Display" },
        { value: "added", text: "Added" },
        { value: "updated", text: "Updated" },
      ],
    };
  },
  methods: {},
  computed: {},
  mounted() {
    this.itemSlug = this.$route?.params?.item ? this.$route.params.item : null;
    // this.getList();
  },
};
</script>

<style scoped></style>
